import { motion } from "framer-motion";

// Heartbeat + soundwave motif. Color via `color` prop (CSS value, supports var()).
export default function Waveform({ color = "rgb(var(--chalk))", className = "" }) {
  return (
    <div className={`w-full overflow-hidden ${className}`} data-testid="waveform-divider">
      <svg viewBox="0 0 1200 60" fill="none" className="w-full h-10" preserveAspectRatio="none">
        <motion.path
          d="M0 30 H180 L210 30 L230 8 L250 52 L270 30 L300 30 L330 18 L360 42 L390 30 L560 30 L580 4 L600 56 L620 30 L800 30 L830 20 L860 40 L890 30 L1010 30 L1030 12 L1050 48 L1070 30 L1200 30"
          style={{ stroke: color }}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0, opacity: 0.2 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 1.6, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
}
